if (!customElements.get('load-more')) {
  customElements.define('load-more', class LoadMore extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    async init() {
      this.gridWrapperClass = '.collection__grid';
      this.gridWrapper = document.querySelector(this.gridWrapperClass);
      this.paginate = JSON.parse(this.gridWrapper.dataset.paginate);
      this.section = this.dataset.section;
      this.method = this.dataset.method || 'beforeend';
      this.querySelector('a').addEventListener('click', this.loadMore.bind(this));
      this.totalVisible = Math.min(this.paginate.items - this.paginate.current_offset, this.paginate.page_size);
      this.updateProductsCount(this.paginate);

      if(!this.paginate?.next?.url) {
        this.style.display = 'none';
      }

      await this.loadPreviousProducts(this.paginate);

      this.gridWrapper.classList.remove('block-preloader');
      if(this.gridWrapper.parentNode) {
        this.gridWrapper.parentNode.classList.remove('block-preloader');
      }

      window.addEventListener("popstate", function (e) {
        window.location.reload();
      });
    }

    async loadMore(event) {
      event.preventDefault();
      event.stopPropagation();

      const result = await this.loadProducts(`${event.target.href}${event.target.href.includes('?') ? '&' : '?'}section_id=${this.section}`);

      if(!result) {
        return;
      }

      this.paginate = result;

      const params = new URLSearchParams(window.location.search);
      params[params.has('page') ? 'set' : 'append'](
          'page',
          result.current_page
      );

      window.history.pushState(
          {},
          '',
          `${event.target.pathname}?${params.toString()}`
      );

      if(!this.paginate?.next?.url) {
        event.target.style.display = 'none';
        return;
      }

      event.target.href = this.paginate.next.url;
    }

    async loadPreviousProducts (paginate) {
      if(!paginate.hasOwnProperty('previous') || !paginate.previous.hasOwnProperty('url')) {
        return true;
      }

      const requestUrl = `${paginate.previous.url}${paginate.previous.url.includes('?') ? '&' : '?'}section_id=${this.section}`;
      const result = await this.loadProducts(requestUrl, 'afterbegin');

      if(!result) {
        return;
      }

      if(!result.hasOwnProperty('previous') || !result.previous.hasOwnProperty('url')) {
        return true;
      }

      return this.loadPreviousProducts(result);
    }

    updateProductsCount(paginate) {
      const containers = document.querySelectorAll('.js-facet-count');

      containers.forEach(container => {
        container.innerHTML = `You’ve seen ${this.totalVisible} products out of ${paginate.items}`;
      });
    }

    async loadProducts (url, insertMethod = null) {
      return fetch(url)
          .then(response => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const collectionGridHtml = html.querySelector(this.gridWrapperClass);

            if(!collectionGridHtml) {
              return false;
            }

            this.gridWrapper.insertAdjacentHTML(insertMethod ?? this.method, collectionGridHtml.innerHTML);

            const paginate = JSON.parse(collectionGridHtml.dataset.paginate);
            this.totalVisible += Math.min(paginate.items - paginate.current_offset, paginate.page_size);
            this.updateProductsCount(paginate);

            return paginate;
          });
    }
  });
}